import React, { useEffect, useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { t } from 'i18next'

import Loading from '~/components/Loading'
import { Radio } from '~/components/unform'
import { useErrorApiAlert } from '~/hooks/useErrorApiAlert'
import {
  QUERY_KEY,
  listCampaignGoals
} from '~/modules/retailMedia/services/campaign-objective-based'

import { GoalLabel } from './elements/GoalLabel'
import { goalOptions } from './goalOptions'

const goalToRadioOption = (goal: CampaignGoalWithMeta) => ({
  id: goal?.name,
  value: goal?.name,
  label: ({ selected }: { selected: boolean }) => (
    <GoalLabel selected={selected} goal={goal} />
  )
})

const CampaignGoalOptions: React.FC = () => {
  const { data, error, isPending } = useQuery<
    AxiosResponse<GetCampaignGoalsResponse>
  >({
    queryKey: [QUERY_KEY],
    queryFn: async () => {
      const response = await listCampaignGoals()
      if (response?.data?.goals) {
        response.data.goals = [...response.data.goals].sort(
          (a, b) => (b?.range?.max || 0) - (a?.range?.max || 0)
        )
      }
      return response
    }
  })

  const [AlertError, setError] = useErrorApiAlert({
    title: `${t('rm:objectiveBased.goals.list.error.title')} ${t('rm:objectiveBased.goals.list.error.description')}`
  })

  const options: RadioOptionProps[] = useMemo(() => {
    return data?.data?.goals
      ?.filter(item => goalOptions[item?.name])
      ?.map(item => ({
        ...item,
        meta: goalOptions[item?.name]
      }))
      ?.map(goalToRadioOption)
  }, [data?.data?.goals])

  useEffect(() => {
    setError(error)
  }, [error])

  return (
    <div className="mt-3">
      <Loading status={isPending} />
      <Radio
        name="goal"
        options={options}
        layout="responsive-flex"
        itemSize="small"
      />
      <AlertError />
    </div>
  )
}

export default CampaignGoalOptions
